<template>
    <div>
        <div class="c-articles">

            <a v-if="featuredArticle && Object.keys(featuredArticle).length > 0" class="c-featured-article" :href="featuredArticle.link">
                <div class="c-featured-article__image-wrapper">
                    <div class="c-featured-article__image" :style="{ backgroundImage: `url(${featuredArticle.imageUrl})` }"></div>
                </div>
                <div class="c-featured-article__details">
                    <h4 class="c-featured-article__date">{{ featuredArticle.date }}</h4>
                    <h3 class="c-featured-article__title">{{ featuredArticle.title }}</h3>
                    <p class="c-featured-article__intro">
                        <span v-html="featuredArticle.summary"></span>
                    </p>
                    <span v-if="featuredArticle.link" class="c-featured-article__readmore readmore">
                        <span class="readmore_boxes">
                            <span class="readmore__box readmore__box--top"></span>
                            <span class="readmore__box readmore__box--middle"></span>
                            <span class="readmore__box readmore__box--bottom"></span>
                        </span>
                        Read more
                    </span>
                </div>
            </a>

            <div
                v-for="article in initialArticles"
                :class="[
                    `c-article`,
                    { 'c-article--loading': loading },
                ]"
                :key="article.title + article.id"
            >
                <div class="c-article__wrapper">

                    <a :href="article.link" v-if="article.imageTitle" class="c-article__image-wrapper">
                        <picture class="c-article__picture">
                            <source
                                media="(max-width: 450px)"
                                type="image/webp"
                                :srcset="article.imageMobile">
                            <source
                                media="(max-width: 550px)"
                                type="image/webp"
                                :srcset="article.imageTablet">
                            <source
                                media="(max-width: 2900px)"
                                type="image/webp"
                                :srcset="article.imageDesktop">
                            <img
                                class="c-article__picture-image"
                                :src="article.imageTablet"
                                width="465"
                                height="450"
                                :alt="article.imageTitle">
                        </picture>
                    </a>

                    <p class="c-article__date">
                        Updated
                        {{ article.date }}
                    </p>

                    <h3 class="c-article__title">
                        <a :href="article.link" class="c-article__link">
                            {{ article.title }}
                        </a>
                    </h3>

                    <p 
                        v-if="article.summary" 
                        class="c-article__excerpt"
                    >
                        <span v-html="article.summary"></span>
                        <a                        
                            class="c-article__readmore readmore"
                            :href="article.link"
                        >
                            <span class="readmore_boxes">
                                <span class="readmore__box readmore__box--top"></span>
                                <span class="readmore__box readmore__box--middle"></span>
                                <span class="readmore__box readmore__box--bottom"></span>
                            </span>
                            Read more
                        </a>
                    </p>
                    
                </div>
            </div>
            
        </div>

        <div
            class="c-algolia-search__pagination"
            v-if="articlePagination.totalPages > 0"
        >
            <button v-if="articlePagination.currentPage > 1" class="c-algolia-search__pagination-button" @click="changePage(articlePagination.currentPage - 1)" :disabled="articlePagination.currentPage === 1">
                Prev
            </button>
            <div v-else></div>

            <div class="c-algolia-search__pagination-pages-wrapper">
                <button v-for="page in articlePagination.totalPages" :key="page" @click="changePage(page)"
                    :class="[
                        'c-algolia-search__pagination-button',
                        {
                            'c-algolia-search__pagination-button--active':
                            page === articlePagination.currentPage,
                        },
                    ]"
                >
                    {{ page }}
                </button>
            </div>

            <button v-if="articlePagination.currentPage < articlePagination.totalPages" class="c-algolia-search__pagination-button" @click="changePage(articlePagination.currentPage + 1)" :disabled="articlePagination.currentPage === articlePagination.totalPages">
                Next
            </button>
            <div v-else></div>

        </div>

    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    // data() {
    //     return {
    //         newsMediaPage: false,
    //     };
    // },
    // mounted() {
    //     if (!this.$store.state.searchApp.state.hasSearched && document.querySelector(".news-media-search")) { 
    //         this.newsMediaPage = true;

    //         // get initial featured article and 8 latest articles
    //         this.$store.dispatch("fetchArticles");
    //     }
    // },
    
    computed: {
        ...mapFields([
            "searchApp.state.hasSearched",
            "searchApp.state.loading",
            "searchApp.search.start",
            "searchApp.featuredArticle",
            "searchApp.initialArticles",
            "searchApp.articlePagination",
        ]),
    },
    methods: {
        changePage(page) {
            this.$store.dispatch("fetchArticles", page);
        }
    },
};

</script>